<!--
  Agent area (route /#/cp/dashboard/agents).

  <mvs-review-workbench> is the ONLY layout owner (splitter, viewport height, per-pane scroll).
  The detail pane's visibility is controlled via [panes], NOT via an @if around the workbench:
  1- and 2-pane mode render the same splitter, the detail pane is collapsed via CSS.
  This is the only way the agent table projected on the left survives the first row click (it is
  never remounted, never reloads, and keeps its sort order and scroll position).
  Exactly ONE instantiation site per slot. Precedent: ns-dashboard-overview.component.html.
-->
<div class="cp-provision-agents">

    <mvs-review-workbench
            [panes]="selectedProvisionAgentId ? 2 : 1"
            [panelSizes]="[58, 42]"
            [minSizes]="[30, 25]"
            [autoFitViewport]="true"
            [viewportBottomGapRem]="2">

        <!-- LEFT: the agent worklist. Persistent — exactly one instantiation site. -->
        <ng-template #workbenchList>
            <div class="cp-agents-pane surface-card border-round p-3">

                <!-- While a cp job runs the balances are an interim state. The hint sits
                     INSIDE the pane: above the workbench it would shift autoFitViewport's viewport
                     arithmetic the moment a job starts. -->
                @if (jobRunning) {
                    <div class="flex align-items-center gap-2 mb-3 p-3 border-round-xl bg-orange-100 text-orange-800">
                        <i class="fa-solid fa-spinner fa-spin"></i>
                        <span class="text-sm">
                            Hintergrundprozesse laufen – die Salden werden nach Abschluss automatisch aktualisiert.
                        </span>
                    </div>
                }

                <!-- Optional narrowing; the search itself is the widget's own header search
                     (magnifier icon in the table header). -->
                <div class="flex align-items-center gap-2 mb-2">
                    <p-toggleSwitch inputId="cpAgentsOnlyWithBookings"
                                    [(ngModel)]="onlyWithBookings"
                                    (onChange)="handleOnlyWithBookingsChange()">
                    </p-toggleSwitch>
                    <label for="cpAgentsOnlyWithBookings"
                           class="text-sm"
                           pTooltip="Zeigt nur Abrechnungskonten, für die Salden berechnet wurden — also Berater mit mindestens einer Buchung (berechnet oder aktiv).">
                        Nur Konten mit Buchungen
                    </label>
                </div>

                @if (initialized && agentsWidget) {
                    <mvs-widget #agentsWidgetRef
                            [widgetData]="agentsWidget"
                            (onObjectSelect)="handleAgentSelect($event)">
                    </mvs-widget>
                } @else {
                    <p-skeleton height="2rem" styleClass="mb-3"></p-skeleton>
                    <p-skeleton height="3rem" styleClass="mb-2"></p-skeleton>
                    <p-skeleton height="3rem" styleClass="mb-2"></p-skeleton>
                    <p-skeleton height="3rem"></p-skeleton>
                }

            </div>
        </ng-template>

        <!-- RIGHT: the selected agent in object mode. The pane stays mounted at all times,
             only its CONTENT is conditional — so an <mvs-object> without an id never occurs.
             The registry resolves 'cp.ProvisionAgent' to CpProvisionAgentObjectComponent. -->
        <ng-template #workbenchDetail>
            @if (selectedProvisionAgentId) {
                <div class="cp-agents-pane cp-agents-detail-pane surface-card border-round p-3">

                    <div class="flex justify-content-end mb-2">
                        <p-button
                                label="Auswahl aufheben"
                                icon="fa-regular fa-xmark"
                                severity="secondary"
                                [text]="true"
                                (onClick)="handleClearSelection()">
                        </p-button>
                    </div>

                    <mvs-object #agentObjectRef
                            [objectType]="'cp.ProvisionAgent'"
                            [objectId]="selectedProvisionAgentId">
                    </mvs-object>

                </div>
            }
        </ng-template>

    </mvs-review-workbench>

</div>
